import {
  SIGNIN_START,
  SIGNIN_SUCCESS,
  SIGNIN_ERROR,
  LOGOUT_START,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  START_FORGOT_PASSWORD,
  SUCCESS_FORGOT_PASSWORD,
  ERROR_FORGOT_PASSWORD,
  RESET_STATE,
  START_RESET_PASSWORD,
  SUCCESS_RESET_PASSWORD,
  ERROR_RESET_PASSWORD,
  START_VERIFY_RESET_PASSWORD_LINK,
  SUCCESS_VERIFY_RESET_PASSWORD_LINK,
  ERROR_VERIFY_RESET_PASSWORD_LINK,
  START_PHARMACY_CREATE_PASSWORD,
  SUCCESS_PHARMACY_CREATE_PASSWORD,
  ERROR_PHARMACY_CREATE_PASSWORD,
} from "Actions/AuthAction";

const initialState = {
  loginDetail: {
    success: null,
    isLoading: false,
    data: {},
    message: "",
    errors: {},
  },
  forgotPasswordDetail: {
    isLoading: false,
    data: {},
    errors: {},
    success: null,
    message: "",
  },
  resetPasswordDetail: {
    isLoading: false,
    data: {},
    errors: {},
    success: null,
    message: "",
  },
  verifyRestPasswordLink: {
    isLoading: false,
    data: {},
    errors: {},
    success: null,
    message: "",
  },
  logoutData: {
    success: null,
    isLoading: false,
    data: [],
    message: "",
  },
  createPharmacyPasswordDetails: {
    isLoading: false,
    data: {},
    errors: {},
    success: null,
    message: "",
  },
};

const AuthReducers = (previousState = initialState, action) => {
  switch (action.type) {
    case SIGNIN_START: {
      return {
        ...previousState,
        loginDetail: {
          ...previousState.loginDetail,
          isLoading: true,
        },
      };
    }
    case SIGNIN_SUCCESS: {
      return {
        ...previousState,
        loginDetail: {
          ...previousState.loginDetail,
          success: true,
          isLoading: false,
          data: action,
          message: action.data.message,
        },
      };
    }
    case SIGNIN_ERROR: {
      return {
        ...previousState,
        loginDetail: {
          ...previousState.loginDetail,
          success: false,
          isLoading: false,
          message: action.data.message,
          errors: action.data.errors,
        },
      };
    }
    case START_FORGOT_PASSWORD: {
      return {
        ...previousState,
        forgotPasswordDetail: {
          ...previousState.forgotPasswordDetail,
          isLoading: true,
        },
      };
    }
    case SUCCESS_FORGOT_PASSWORD: {
      return {
        ...previousState,
        forgotPasswordDetail: {
          ...previousState.forgotPasswordDetail,
          isLoading: false,
          success: true,
          message: action.payload.message,
        },
      };
    }
    case ERROR_FORGOT_PASSWORD: {
      return {
        ...previousState,
        forgotPasswordDetail: {
          ...previousState.forgotPasswordDetail,
          success: false,
          isLoading: false,
          message: action.payload.message,
          errors: action.payload.errors,
        },
      };
    }
    case START_VERIFY_RESET_PASSWORD_LINK: {
      return {
        ...previousState,
        verifyRestPasswordLink: {
          ...previousState.verifyRestPasswordLink,
          isLoading: true,
        },
      };
    }
    case SUCCESS_VERIFY_RESET_PASSWORD_LINK: {
      return {
        ...previousState,
        verifyRestPasswordLink: {
          ...previousState.verifyRestPasswordLink,
          isLoading: false,
          success: true,
          message: action.payload.message,
        },
      };
    }
    case ERROR_VERIFY_RESET_PASSWORD_LINK: {
      return {
        ...previousState,
        verifyRestPasswordLink: {
          ...previousState.verifyRestPasswordLink,
          success: false,
          isLoading: false,
          message: action.payload.message,
          errors: action.payload.errors,
        },
      };
    }
    case START_RESET_PASSWORD: {
      return {
        ...previousState,
        resetPasswordDetail: {
          ...previousState.resetPasswordDetail,
          isLoading: true,
        },
      };
    }
    case SUCCESS_RESET_PASSWORD: {
      return {
        ...previousState,
        resetPasswordDetail: {
          ...previousState.resetPasswordDetail,
          isLoading: false,
          success: true,
          message: action.payload.message,
        },
      };
    }
    case ERROR_RESET_PASSWORD: {
      return {
        ...previousState,
        resetPasswordDetail: {
          ...previousState.resetPasswordDetail,
          success: false,
          isLoading: false,
          message: action.payload.message,
          errors: action.payload.errors,
        },
      };
    }
    case LOGOUT_START: {
      return {
        ...previousState,
        logoutData: {
          ...previousState.logoutData,
          isLoading: true,
        },
      };
    }
    case LOGOUT_SUCCESS: {
      return {
        ...previousState,
        logoutData: {
          ...previousState.logoutData,
          isLoading: false,
          success: true,
          message: action.payload.message,
        },
      };
    }
    case LOGOUT_ERROR: {
      return {
        ...previousState,
        logoutData: {
          ...previousState.logoutData,
          success: false,
          isLoading: false,
          message: action.payload.message,
          errors: action.payload.errors,
        },
      };
    }
    case RESET_STATE: {
      return {
        ...previousState,
        [action.key]: action.payload || initialState[action.key],
      };
    }
    case START_PHARMACY_CREATE_PASSWORD: {
      return {
        ...previousState,
        createPharmacyPasswordDetails: {
          ...previousState.createPharmacyPasswordDetails,
          isLoading: true,
        },
      };
    }
    case SUCCESS_PHARMACY_CREATE_PASSWORD: {
      return {
        ...previousState,
        createPharmacyPasswordDetails: {
          ...previousState.createPharmacyPasswordDetails,
          isLoading: false,
          success: true,
          message: action.payload.message,
        },
      };
    }
    case ERROR_PHARMACY_CREATE_PASSWORD: {
      return {
        ...previousState,
        createPharmacyPasswordDetails: {
          ...previousState.createPharmacyPasswordDetails,
          success: false,
          isLoading: false,
          message: action.payload.message,
          errors: action.payload.errors,
        },
      };
    }
    default: {
      return previousState || initialState;
    }
  }
};

export default AuthReducers;
